<mbs-card-group>
  <ng-container *ngTemplateOutlet="credsTmp"></ng-container>
</mbs-card-group>
<mbs-card-group>
  <ng-container *ngTemplateOutlet="optionsTmp"></ng-container>
</mbs-card-group>

<ng-template #credsTmp>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.user"
      [boldLabel]="true"
      [formControl]="user"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.username' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.username' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.password"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="password.value === fakeSecretKey"
      [formControl]="password"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.password' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.password' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.endpoint"
      [boldLabel]="true"
      [formControl]="endpoint"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.address' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.address' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
</ng-template>

<ng-template #optionsTmp>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.isPrivateStorage"
      [formControl]="isPrivateStorage"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.checkCredentials' | i18next"></mbs-checkbox>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.useSSL"
      [formControl]="useSSL"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.useSSL' | i18next"></mbs-checkbox>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.keepAlive"
      [formControl]="keepAlive"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.keepAlive' | i18next"></mbs-checkbox>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.usePassiveMode"
      [formControl]="usePassiveMode"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.usePassiveMode' | i18next"></mbs-checkbox>
  </mbs-form-group>
</ng-template>
